export default __webpack_public_path__ + "static/media/stilllife.84a185d7.png";